(() => {
    class UserCreatedModalController {
        constructor(
            $scope,
            $uibModalInstance,
            userId,
            firstName,
            lastName,
            manageUserById
        ) {
            $scope.firstName = firstName;
            $scope.lastName = lastName;
            $scope.confirm = function () {
                $uibModalInstance.close();
                manageUserById(userId);
            }
        }
    }

    angular.module('dashboard')
        .controller('UserCreatedModalController', [
            '$scope',
            '$uibModalInstance',
            'userId',
            'firstName',
            'lastName',
            'manageUserById',
            UserCreatedModalController
        ]);
})();
